import React from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function RegisterQRCode({ totemId }) {
  const id = totemId ?? 0;
  const registrationUrl = `https://psicopatici.com/register/${id}`;

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "20px",
      backgroundColor: "transparent",
    }}>
      <h1 style={{
        fontSize: "36px",
        fontWeight: "bold",
        marginBottom: "20px",
        color: "#000"
      }}>
        Registrati
      </h1>

      <QRCodeCanvas
        value={registrationUrl}
        size={180}
        bgColor="transparent"
        fgColor="#000000"
        level="H"
        includeMargin={true}
        style={{ borderRadius: "12px" }}
      />

      <p style={{ marginTop: "20px", fontSize: "16px", color: "#444" }}>
        Scansiona il QR Code per completare la registrazione
      </p>
    </div>
  );
}
